var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 19,
    width: 28,
    xmlns: "http://www.w3.org/2000/svg",
    className: "social-link-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 11.914 12.366 L 0 20.123 L 0 4.609 L 11.914 12.366 Z M 27.086 12.366 L 39 20.123 L 39 4.609 L 27.086 12.366 Z M 25.345 13.503 L 20.018 16.97 C 19.861 17.069 19.68 17.122 19.5 17.122 C 19.32 17.122 19.139 17.069 18.982 16.97 L 13.655 13.503 L 0.79 21.878 L 0.042 22.364 C 0.276 23.704 1.446 24.732 2.854 24.732 L 36.146 24.732 C 37.554 24.732 38.724 23.709 38.958 22.364 L 38.205 21.878 L 25.345 13.503 Z M 19.5 15.034 L 38.205 2.854 L 38.958 2.369 C 38.724 1.023 37.554 0 36.146 0 L 2.854 0 C 1.446 0 0.276 1.028 0.042 2.369 L 0.79 2.854 L 19.5 15.034 Z",
    transform: "scale(0.72)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.b1a6038ab838c0267c478f9b82fedad1.svg";
export { ForwardRef as ReactComponent };